import { TImage } from '@/client/types/Images';
import React, { FC } from 'react';

interface ListingImageProps {
  image: TImage;
  loadingType?: 'eager' | 'lazy';
  decodingType?: 'sync' | 'async' | 'auto';
  fetchPriority?: 'auto' | 'high' | 'low';
}

const ListingImage: FC<ListingImageProps> = ({ image, loadingType, decodingType, fetchPriority }) => {
  return (
    <img
      suppressHydrationWarning
      title={image.title}
      alt={image.alt}
      data-src={image.imageSource}
      src={image.imageSource}
      loading={loadingType}
      decoding={decodingType}
      fetchPriority={fetchPriority}
    />
  );
};

export default ListingImage;
